// extracted by mini-css-extract-plugin
module.exports = {"formBox":"styles_formBox__28R79"};